module.exports = {"513435100":"新市坝镇","513435101":"田坝镇","513435102":"海棠镇","513435103":"吉米镇","513435104":"斯觉镇","513435105":"普昌镇","513435106":"玉田镇","513435200":"前进乡","513435201":"胜利乡","513435202":"新茶乡","513435203":"两河乡","513435204":"里克乡","513435205":"尼尔觉乡","513435206":"拉莫乡","513435207":"波波乡","513435208":"阿嘎乡","513435209":"阿尔乡","513435210":"石海乡","513435211":"团结乡","513435212":"嘎日乡","513435213":"则拉乡","513435214":"坪坝乡","513435215":"蓼坪乡","513435216":"阿兹觉乡","513435217":"乌史大桥乡","513435218":"黑马乡","513435219":"沙岱乡","513435220":"苏雄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513435.json
// module id = 2258
// module chunks = 0